import { useEffect, useState } from 'react';
import { notification, Table, Pagination, Empty, Button, Popconfirm, Row, Col, Space, Input, Tooltip } from "antd";
import { getDeviceRestrictions,opDeviceRestrictions } from "@axios/api.device";
import { useTranslation } from "react-i18next";
import { InfoCircleOutlined } from '@ant-design/icons';

interface propsModel {
    id: string,
}

const { Column } = Table;

export const DeviceDetailRestrictions = (props: propsModel) => {
    const { id } = props;
    const [data, setData] = useState<any>();
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [search, setSearch] = useState<string>("");
    const { t } = useTranslation();

    useEffect(() => { if (id) { getData() } }, []);

    const getData = (index = pageIndex, size = pageSize) => {
        getDeviceRestrictions(id, { pageIndex: index, pageSize: size, search: search }).then(
            (res) => {
                const { dataList, pageIndex, pageSize, totalCount } = res;
                if (dataList.length > 0) {
                    dataList.map((item: any, itemIndex: number) => {
                        item["index"] = itemIndex;
                        return item;
                    })
                }
                setData(dataList);
                setPageIndex(pageIndex);
                setPageSize(pageSize);
                setTotalCount(totalCount);
            },
            () => { notification.error({ message: t("获取数据失败") }) },
        )
    }

    const deleteClick = (key: string) => {
        opDeviceRestrictions(id, {key: key, isRemove: true}).then(() => {
        notification.success({message: t("操作成功，需要同步后再刷新列表数据")});
        getData();
        })
    }

    const addClick = (key: string) => {
        opDeviceRestrictions(id, {key: key, isRemove: false}).then(() => {
        notification.success({message: t("操作成功，需要同步后再刷新列表数据")});
        getData();
        })
    }

    return (
        <>
            <Row className="mb-2" justify="space-between">
                <Col>
                <Space>
                    <div style={{display: "flex"}}>
                    <Input
                        placeholder={t("输入关键词搜索")}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    ></Input>
                
                    <Button type="primary" onClick={() => { getData(1);}}>{t("查询")}</Button>
                    </div>
                    <Tooltip placement="right" title={t("限制数据有延迟，需要进行同步操作后才会更新")} overlayStyle={{fontSize: "12px"}}>
                    <span style={{marginLeft: "10px"}}><InfoCircleOutlined /></span>
                    </Tooltip>
                </Space>
                </Col>
                {/* <Col>
                    <Select  style={{width:100}} onChange={(e)=>{console.log("e")}}>
                    <Select.Option value="">全部</Select.Option>
                    <Select.Option value="Success">成功</Select.Option>
                    <Select.Option value="Pending">未执行</Select.Option>
                    <Select.Option value="Fail">失败</Select.Option>
                    </Select>
                </Col>
                <Col>
                <Input  style={{width:100}}></Input>
                </Col>
                <Col>
                <Button type="primary" onClick={() => { getData() }}> {t("查询")} </Button>
                </Col> */}
                {/* <Col>
                <Button type="primary" onClick={() => { clearProcessingOperation(); gaEvent("clearProcessingOperation", "onClick", "clearProcessingOperation") }}>{t("清除处理中操作")}</Button>
                </Col> */}
            </Row>
            <Table 
                dataSource={data} 
                pagination={false} 
                rowKey="index"
                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
            >
                <Column title={t("Key")} key="key" dataIndex="key"></Column>
                <Column title={t("名称")} key="name" dataIndex="name"></Column>
                {/* <Column title={t("值")} key="value" dataIndex="value" ></Column> */}
                <Column
                    title={t("操作")}
                    key="operation"
                    dataIndex="operation"
                    render={(v, row: any) => {
                        if (row.valueType !== 'boolean') {
                            return null;
                        }
                        if (row.isRemove) {
                            return (
                                <Popconfirm 
                                    title={t("确认恢复限制")} 
                                    onConfirm={() => { addClick(row.key) }}
                                    okText={t("确认")}
                                    cancelText={t("取消")}
                                >
                                    <Button style={{ color: "#007ACC" }}>{t("恢复限制")}</Button>
                                </Popconfirm>
                                )
                        }
                        else
                        {
                            return (
                            <Popconfirm 
                                title={t("确认暂时解除?")} 
                                onConfirm={() => { deleteClick(row.key) }}
                                okText={t("确认")}
                                cancelText={t("取消")}
                            >
                                <Button style={{ color: "#007ACC" }}>{t("暂时解除")}</Button>
                            </Popconfirm>
                            )
                        }
                    }}
                ></Column>
            </Table>
            <Pagination
                style={{textAlign: 'right', marginTop: '20px'}}
                current={pageIndex}
                pageSize={pageSize}
                total={totalCount}
                showTotal={(total, range) => `${range[0]}-${range[1]} / ${total}${t("条")}`}
                onChange={(page, pageSize) => { getData(page, pageSize) }}
                onShowSizeChange={(current, size) => { getData(current, size) }}
            ></Pagination>
        </>
    )
}

